
import React, { useEffect, useRef, useState } from 'react';
import './Hero.css';

// Desktop landscape images
const DESKTOP_IMAGES = [
  '/images/hero-jewelry.jpeg',
  '/images/hero-hair-accessory.jpeg',
  '/images/hero-blouse.jpeg',
];

// Tablet portrait images
const TABLET_IMAGES = [
  '/images/mobile-portrait-1.jpeg',
  '/images/mobile-portrait-2.jpeg',
  '/images/mobile-portrait-3.jpeg',
];

// Mobile portrait images
const MOBILE_IMAGES = [
  '/images/mobile-portrait-1.jpeg',
  '/images/mobile-portrait-2.jpeg',
  '/images/mobile-portrait-3.jpeg',
];

const SLIDE_DURATION = 5000;

const Hero = () => {
  const heroRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const [screenType, setScreenType] = useState(() => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      return 'mobile';
    }

    if (window.matchMedia('(max-width: 1024px)').matches) {
      return 'tablet';
    }

    return 'desktop';
  });

  useEffect(() => {
    const desktopQuery = window.matchMedia('(min-width: 1025px)');
    const tabletQuery = window.matchMedia(
      '(min-width: 769px) and (max-width: 1024px)'
    );
    const mobileQuery = window.matchMedia('(max-width: 768px)');

    const updateScreen = () => {
      if (mobileQuery.matches) {
        setScreenType('mobile');
      } else if (tabletQuery.matches) {
        setScreenType('tablet');
      } else if (desktopQuery.matches) {
        setScreenType('desktop');
      }
    };

    updateScreen();

    desktopQuery.addEventListener('change', updateScreen);
    tabletQuery.addEventListener('change', updateScreen);
    mobileQuery.addEventListener('change', updateScreen);

    return () => {
      desktopQuery.removeEventListener('change', updateScreen);
      tabletQuery.removeEventListener('change', updateScreen);
      mobileQuery.removeEventListener('change', updateScreen);
    };
  }, []);

  const images =
    screenType === 'mobile'
      ? MOBILE_IMAGES
      : screenType === 'tablet'
        ? TABLET_IMAGES
        : DESKTOP_IMAGES;

  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;

    const timeout = setTimeout(() => {
      hero.classList.add('loaded');
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    setActiveIndex(0);

    const interval = setInterval(() => {
      setActiveIndex((previous) => (previous + 1) % images.length);
    }, SLIDE_DURATION);

    return () => clearInterval(interval);
  }, [screenType, images.length]);

  return (
    <section
      className={`hero hero-${screenType}`}
      ref={heroRef}
    >
      <div className="hero-bg">
        {images.map((src, index) => (
          <div
            key={src}
            className={`hero-bg-slide ${
              index === activeIndex ? 'active' : ''
            }`}
            style={{ backgroundImage: `url("${src}")` }}
          />
        ))}

        <div className="hero-overlay" />
      </div>

      <div className="hero-content">
        <div className="hero-divider" />
      </div>

      <div className="hero-scroll">
        <span>SCROLL</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
};

export default Hero;
